/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Rights_Objection_LabelInputs */

const es_privacy_policy_rights_objection_label = /** @type {(inputs: Privacy_Policy_Rights_Objection_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oposicion`)
};

const en_privacy_policy_rights_objection_label = /** @type {(inputs: Privacy_Policy_Rights_Objection_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objection`)
};

/**
* | output |
* | --- |
* | "Objection" |
*
* @param {Privacy_Policy_Rights_Objection_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_rights_objection_label = /** @type {((inputs?: Privacy_Policy_Rights_Objection_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Rights_Objection_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_rights_objection_label(inputs)
	return en_privacy_policy_rights_objection_label(inputs)
});
export { privacy_policy_rights_objection_label as "privacy_policy.rights.objection_label" }